var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Animation } from '../../../../lib/classes/animation';
var TextEffect = /** @class */ (function (_super) {
    __extends(TextEffect, _super);
    function TextEffect(props) {
        var _this = _super.call(this, props) || this;
        _this.maxTime = 1500;
        _this.text = props.text;
        _this.x = props.x || 0;
        _this.y = props.y || 0;
        _this.fontSize = props.fontSize || 40;
        _this.color = props.color || '#cccc00';
        _this.shadowColor = props.shadowColor || '#0033CC';
        _this.vy = props.vy !== undefined ? props.vy : -0.02; // Скорость по Y
        _this.vz = props.vz !== undefined ? props.vz : 0.005; // Скорость вращения вокруг Z
        _this.az = props.az !== undefined ? props.az : 0.1; // Амплитуда вращения вокруг Z
        _this.vf = props.vf !== undefined ? props.vf : 0.01; // Скорость изменения шрифта
        _this.af = props.af !== undefined ? props.af : 20; // Амплитуда изменения шрифта
        _this.textDepth = props.textDepth !== undefined ? props.textDepth : 0;
        return _this;
    }
    TextEffect.prototype.upd = function (dt) {
        _super.prototype.upd.call(this, dt);
        if (this.done)
            return;
    };
    TextEffect.prototype.draw = function (scene) {
        scene.save();
        var y = this.y + this.time * this.vy;
        scene.translate(this.x, y);
        scene.rotate(Math.sin(this.time * this.vz) * this.az);
        var fontSize = this.fontSize;
        var angle = this.time * this.vf;
        if (angle <= Math.PI)
            fontSize += Math.sin(angle) * this.af;
        scene.draw3dText({
            text: this.text,
            x: 0,
            y: 0,
            textDepth: this.textDepth,
            fontSize: fontSize,
            color: this.color,
            shadowColor: this.shadowColor,
        });
        scene.restore();
    };
    return TextEffect;
}(Animation));
export { TextEffect };
